import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import SettlementView from "../views/SettlementView.vue";

Vue.use(VueRouter);

// Suppress NavigationDuplicated console warnings when navigating to identical route
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location: any) {
  return (originalPush.call(this, location) as any)?.catch?.((err: any) => {
    if (err && err.name !== "NavigationDuplicated") {
      throw err;
    }
  });
};

const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location: any) {
  return (originalReplace.call(this, location) as any)?.catch?.((err: any) => {
    if (err && err.name !== "NavigationDuplicated") {
      throw err;
    }
  });
};

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "SettlementRoot",
    component: SettlementView,
  },
  {
    path: "/calendar/:month?",
    name: "CalendarView",
    component: SettlementView,
  },
  {
    path: "/chart/:month?",
    name: "ChartView",
    component: SettlementView,
  },
  {
    path: "/detail/:startDate/:endDate?",
    name: "DetailView",
    component: SettlementView,
  },
  {
    path: "/orders/:startDate/:endDate?",
    name: "OrdersView",
    component: SettlementView,
  },
  {
    path: "/settings/pg-fee/:tab?",
    name: "PgFeeSettings",
    component: SettlementView,
  },
  {
    path: "/guide/:step?",
    name: "OnboardingGuide",
    component: SettlementView,
  },
  {
    path: "/saved-results/:month?",
    name: "SavedResults",
    component: SettlementView,
  },
  {
    path: "*",
    redirect: "/",
  },
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
});

export default router;
